// extracted by mini-css-extract-plugin
module.exports = {"option":"FoodModalOption_option__uIAZy","name":"FoodModalOption_name__2XWKv","price":"FoodModalOption_price__3Ipyy","option-details":"FoodModalOption_option-details__3yyCC"};